module.exports = __webpack_public_path__ + "media/images/emblems/Zillis-Reischen_wappen-06fa419d36136b905376ff3263f0ba98.svg";